import { registerWorkflowProduct } from "src/views/products/workflow/registry";

/** The one place the chat URL shape lives; every navigation goes through it. */
export const itemEquivalencyChatUrl = (dialogueId: number) =>
  `/item-equivalency/chat/${dialogueId}`;

/**
 * The Item Equivalency Evaluation product (Parts AI 1.33).
 *
 * productKey is the backend product slug — sending it as
 * `conversation.product` (at create-dialogue AND per converse turn) is what
 * activates the workflow delegation tools and the lead persona resolver.
 * licenseModule stays "parts-ai": a new product does not imply a new
 * entitlement (same rule as 50.59 staying on licensing-compliance).
 */
export const ITEM_EQUIVALENCY_PRODUCT = registerWorkflowProduct({
  productKey: "item-equivalency",
  licenseModule: "parts-ai",
  displayName: "Item Equivalency",
  // The consolidated entry point: evaluations start from the Parts AI
  // comparison splash. Chat URLs stay under /item-equivalency/chat (see
  // buildChatUrlForDialogue) so in-flight dialogues and history links hold.
  basePath: "/parts/compare",
  streamKey: "item-equivalency",
  testIdPrefix: "peq",
  leadSlotKey: "lead",
  // No runId URL segment: the record is reachable through the dialogue.
  buildChatUrlForDialogue: () => async (dialogueId: number) =>
    itemEquivalencyChatUrl(dialogueId),
});
